// extracted by mini-css-extract-plugin
export default {"customer_field__label":"CustomerField_customer_field__label__H1ycL"};